import * as React from "react";

const PlusIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2118_5306)"
    >
      <path d="M3 8h11M8.5 2.5v11"></path>
    </g>
    <defs>
      <clipPath id="clip0_2118_5306">
        <path fill="#fff" d="M.5 0h16v16H.5z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default PlusIcon;
